import * as yup from 'yup';

export const blogShema = yup.object().shape({
  title: yup.string().required('Title is required field').max(60, 'Title must be at most 60 characters'),
  description: yup.string().required('Description is required field'),
  content: yup.string().required('Content is required field'),
  tag: yup.string().required("Tag is required field"),
  picture: yup.mixed().required('Picture is required field'),
});